<script setup lang="ts">
const props = defineProps<{
  amount: number | null;
  currentNisab: number;
  isEligible: boolean;
  formattedZakat: string;
  belowNisab: string;
  resultTitle: string;
  resultNote: string;
}>();
</script>

<template>
  <transition name="fade-result">
    <section
      v-if="amount && amount > 0"
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-5 space-y-2"
    >
      <p
        v-if="!isEligible && amount < currentNisab"
        class="text-base text-gray-700 dark:text-gray-300"
      >
        {{ belowNisab }}
      </p>

      <template v-else>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ resultTitle }}
        </p>
        <p class="text-3xl font-semibold text-gray-900 dark:text-gray-100">
          Rs {{ formattedZakat }}
        </p>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ resultNote }}
        </p>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Agar chahein to isay round up bhi kar sakte hain.
        </p>
      </template>
    </section>
  </transition>
</template>

<style scoped>
.fade-result-enter-active,
.fade-result-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-result-enter-from,
.fade-result-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

.fade-result-enter-to,
.fade-result-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
